import styled from 'styled-components/macro';
import { Col, Container, Row } from '@yme/atoms/grid';
import { MiniButton } from '@yme/atoms/mini-button';
import { SVGIconStyled } from '@yme/atoms/svg-icon';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { getTextStyles } from '@yme/utils/styles';
export const ContentContainerStyled = styled(Container) `
  ${Row} {
    ${ADAPTIVE.maxWidth.mobile} {
      margin-left: 0;
      margin-right: 0;
      max-width: 100%;
    }
  }

  ${Col} {
    ${ADAPTIVE.maxWidth.mobile} {
      max-width: 100%;
      margin-right: 0;
      margin-left: 0;
      flex: auto;
    }
  }
`;
export const InfoSectionContainerStyled = styled.div `
  padding: 16px;

  ${ADAPTIVE.minWidth.tablet} {
    padding: 24px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding: 48px;
  }
`;
// Common content block-wrapper
export const FlexWrapperStyled = styled(FlexWrapper) `
  gap: 32px;
  padding-top: 32px;
  padding-bottom: 56px;

  ${ADAPTIVE.minWidth.tablet} {
    gap: 24px;
    padding-top: 32px;
    padding-bottom: 64px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding-top: 48px;
    padding-bottom: 96px;
  }

  ${ADAPTIVE.minWidth.desktopLg} {
    gap: 36px;
  }
`;
export const DownLoadButtonStyled = styled(MiniButton) `
  margin-bottom: 32px;
  padding: 0;

  ${getTextStyles('Ubuntu', 400, 16, 24)}
  text-transform: capitalize;

  ${SVGIconStyled} {
    margin-right: 12px;
  }
`;
export const FileNameStyled = styled.span `
  text-decoration: underline;
`;
export const FileSizeStyled = styled.span `
  text-transform: uppercase;
  color: ${colorCoreBlack300};
`;
